module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exceeded":"Limit exceeded!"},"de":{"exceeded":"Limit überschritten!"},"fr":{"exceeded":"Limite dépassée !"},"it":{"exceeded":"Limite superato!"}}')
  delete Component.options._Ctor
}
